import { B2Button } from "@hdb/biome-2";
import * as moment from "moment";
import { createRef, FC, useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomStackedChartComponent from "src/shared/custom-highchart-component/custom-stacked-chart.component";
import { DAY, MONTH, MotionVsTime } from "src/shared/helpers/current-month";
import { generateFilenameWithTimestamp } from "src/shared/helpers/generateFilenameWithTimestamp";
import { assetsByBlock } from "src/store/slices/asset.slice";
import * as yup from "yup";
import pdfIcon from "../../../assets/images/pdfBiomeIcon.svg";
import spreadsheetIcon from "../../../assets/images/spreadsheetIconBiome.svg";
import HasPermission from "../../../core/guards/has-permission";
import CustomHighChartComponent from "../../../shared/custom-highchart-component/custom-highchart.component";
import CustomSpinnerComponent from "../../../shared/custom-spinner/custom-spinner.component";
import FilterFormComponent, {
  Control,
  FilterFormConfig,
} from "../../../shared/filter-form/filter-form.component";
import { downloadMotionTrafficReportsFile } from "../../../store/slices/fault-module/motion-traffic-report.slice";
import { getBlocksBySiteCode } from "../../../store/slices/location-block.slice";
import { getSiteByTCCode } from "../../../store/slices/location-site.slice";
import { getTownCouncils } from "../../../store/slices/town-council.slice";
interface MotionTrafficReportTableComponentProps {
  motionVsTimeData: { reportTime: []; countPerHr: [] };
  motionVsSensorData: { sensorIds: []; countPerNode: []; extraData: [] };
  motionCountVsLevelData: {
    seriesData: [];
    xAxisValues: [];
  };
  motionCountVsLocationData: {
    seriesData: [];
    xAxisValues: [];
  };

  onRefetchData: (
    tcCode: any,
    siteCode: any,
    blockCode: any,
    reportType: any,
    startDate: any,
    endDate: any,
    timePeriod: any,
    asset: any
  ) => void;
  isLoading: boolean;
  getSelectedReportType: (reportType: number) => void;
}

const MotionTrafficReportTableComponent: FC<
  MotionTrafficReportTableComponentProps
> = ({
  motionVsTimeData,
  motionVsSensorData,
  motionCountVsLevelData,
  motionCountVsLocationData,
  onRefetchData,
  isLoading,
  getSelectedReportType,
}) => {
    const formRef = createRef();
    const [tcOptions, setTCOptions] = useState<any>([]);
    const [siteOptions, setSiteOptions] = useState<any>([]);
    const [blockOptions, setBlockOptions] = useState<any>([]);
    const [isFiltered, setIsFiltered] = useState<any>(false);

    const [selectedTc, setSelectedTc] = useState<any>(null);
    const [selectedSite, setSelectedSite] = useState<any>(null);
    const [selectedBlock, setSelectedBlock] = useState<any>(null);
    const [selectedAsset, setSelectedAsset] = useState<any>(null);
    const [selectedTimePeriod, setSelectedTimePeriod] = useState<any>(null);
    const [selectedReportType, setSelectedReportType] = useState<any>(null);
    const [selectedFilteredReportType, setSelectedFilteredReportType] =
      useState<any>(null);
    // const [selectedStartDate, setSelectedStartDate] = useState<any>(null);
    // const [selectedEndDate, setSelectedEndDate] = useState<any>(null);

    const [blockChangeDetected, setBlockChangeDetected] = useState(0);
    const [assetOptions, setAssetOptions] = useState<any>([]);
    const [isAssetSearch, setIsAssetSearch] = useState<boolean>(true);
    const [isExportDisabled, setIsExportDisabled] = useState<boolean>(false);

    const [downloaDocumentPayload, setDownloaDocumentPayload] = useState<any>({
      townCouncil: "",
      site: "",
      block: "",
      reportType: "",
      startDate: "",
      endDate: "",
      timePeriod: "",
      asset: "",
    });

    const [filterUpdateCount, setFilterUpdateCount] = useState(0);
    const [timeSelected, setTimeSelected] = useState(false);
    const [timePeriodOptions] = useState([
      {
        label: "Daily",
        value: "1",
      },
      {
        label: "Monthly",
        value: "2",
      },
    ]);

    const reportTypeOptions = [
      {
        label: "Motion vs Time",
        value: "1",
      },
      {
        label: "Motion vs Sensor",
        value: "2",
      },
      {
        label: "Motion vs Level",
        value: "3",
      },
      {
        label: "Motion vs Location",
        value: "4",
      },
    ];

    const dispatch = useDispatch();

    useEffect(() => {
      dispatch(getTownCouncils({ PageNumber: 0, pageSize: 0 }));
    }, [dispatch]);

    const townCouncilData = useSelector((state: any) => {
      return state.townCouncil.townCouncils;
    });

    const isLoadingTownCouncils = useSelector((state: any) => {
      return state.townCouncil.isLoadingTownCouncils;
    });

    const siteDataByTCCode = useSelector((state: any) => {
      return state.locationSite.sitesByTCCode;
    });

    const isLocationSitesByTCCode = useSelector((state: any) => {
      return state.locationSite.isLocationSitesByTCCode;
    });

    const blockDataSiteCode = useSelector((state: any) => {
      return state.locationBlock.blocksBySiteCode;
    });

    const isLoadingBlocksBySiteCode = useSelector((state: any) => {
      return state.locationBlock.isLoadingBlocksBySiteCode;
    });

    const isLoadingMotionTrafficReportsDownload = useSelector((state: any) => {
      return state.motionTrafficReport.isLoadingMotionTrafficReportsDownload;
    });

    const assetsData = useSelector((state: any) => {
      return state.asset.selectedAssetsByBlock;
    });

    useEffect(() => {
      const assetIDs =
        assetsData?.map(
          (asset: { assetCode: string; sensorDisplayName: string }) => ({
            label: asset.sensorDisplayName,
            value: asset.assetCode,
          })
        ) || [];

      if (assetIDs.length > 0) {
        assetIDs.unshift({
          label: "All",
          value: null,
        });
      }

      setAssetOptions(assetIDs);

      if (assetsData?.length > 0) {
        setIsAssetSearch(false);
      }
    }, [assetsData]);
    const [currentTC, setCurrentTC] = useState({ label: "", value: "" });

    useEffect(() => {
      const tcs = townCouncilData?.data?.map((tc: any) => ({
        label: tc?.name,
        value: tc?.tcCode,
      }));

      // if user is TC Admin only 1 tc is available
      if (tcs?.length === 1) {
        setCurrentTC(tcs[0]);
      }

      setTCOptions(tcs);
      setFilterUpdateCount(filterUpdateCount + 1);
    }, [townCouncilData]);

    useEffect(() => {
      if (currentTC.value.length) {
        setFormFilterInitialValues((prev) => ({
          ...prev,
          townCouncil: currentTC.value,
        }));

        dispatch(getSiteByTCCode({ tcCode: currentTC.value }));
      }
    }, [currentTC]);
    useEffect(() => {
      const sites = siteDataByTCCode?.data?.map((site: any) => ({
        label: site?.name,
        value: site?.siteCode,
      }));

      if (!sites?.length) return;

      setSiteOptions(sites);
    }, [siteDataByTCCode]);

    useEffect(() => {
      const blocks = blockDataSiteCode?.data?.map((block: any) => ({
        label: block?.blockName,
        value: block?.blockCode,
      }));

      setBlockOptions(blocks);
    }, [blockDataSiteCode]);

    useEffect(() => {
      if (selectedTc && selectedSite && selectedBlock) {
        dispatch(assetsByBlock({ blockCode: selectedBlock }));
      }
    }, [selectedBlock]);

    useEffect(() => {
      setSiteOptions([]);
      setBlockOptions([]);
    }, []);

    const onChangeTC = (selectedTC: any) => {
      setSiteOptions([]);
      setBlockOptions([]);
      setAssetOptions([]);
      setBlockChangeDetected(blockChangeDetected + 1);
      setSelectedTc(selectedTC);
      setSelectedSite(null);
      setSelectedBlock(null);
      setSelectedAsset(null);
      setFormFilterInitialValues((prevInitValues: any) => ({
        ...prevInitValues,
        townCouncil: selectedTC,
        site: "",
        block: "",
        asset: "",
      }));

      if (!selectedTC) return;

      dispatch(getSiteByTCCode({ tcCode: selectedTC }));
    };

    const onChangeSite = (selectedSite: any) => {
      setBlockOptions([]);
      setAssetOptions([]);
      setSelectedSite(selectedSite);
      setSelectedBlock(null);
      setSelectedAsset(null);
      setBlockChangeDetected(blockChangeDetected + 1);
      setFormFilterInitialValues((prevInitValues: any) => ({
        ...prevInitValues,
        site: selectedSite,
        block: "",
        asset: "",
      }));

      if (!selectedSite) return;

      dispatch(getBlocksBySiteCode({ siteCode: selectedSite }));
    };

    const onChangeBlock = (selectedBlock: any) => {
      setSelectedAsset(null);
      setAssetOptions([]);

      setFormFilterInitialValues((prevInitValues: any) => ({
        ...prevInitValues,
        block: selectedBlock,
        asset: "",
      }));

      if (!selectedBlock) return;

      setSelectedBlock(selectedBlock);
      setBlockChangeDetected(blockChangeDetected + 1);
    };

    const onChangeAsset = (selectedAsset: any) => {
      setSelectedAsset(selectedAsset);
      setFormFilterInitialValues((prevInitValues: any) => ({
        ...prevInitValues,
        asset: selectedAsset,
      }));
    };

    const onChangeReportType = (reportType: any) => {
      // if (reportType == 1) {
      //   setTimePeriodOptions([
      //     {
      //       label: "Daily",
      //       value: "1",
      //     },
      //     {
      //       label: "Monthly",
      //       value: "2",
      //     },
      //   ]);
      // } else {
      //   setTimePeriodOptions([
      //     {
      //       label: "Daily",
      //       value: "1",
      //     },
      //   ]);
      //   setSelectedTimePeriod(DAY);

      // }

      setSelectedTimePeriod(DAY);

      setSelectedReportType(reportType);
      // setSelectedStartDate(null);
      // setSelectedEndDate(null);

      setFormFilterInitialValues((prevInitValues: any) => ({
        ...prevInitValues,
        startDate: "",
        endDate: "",
      }));

      // setDownloaDocumentPayload((prevInitValues: any) => ({
      //   ...prevInitValues,
      //   reportType: reportType,
      // }));

      // setSelecteFiltereddReportType(null);

      if (reportType === MotionVsTime) {
        setTimeSelected(true);
      } else {
        setTimeSelected(false);
        setSelectedAsset(null);
      }

      setFormFilterInitialValues((prevInitValues: any) => ({
        ...prevInitValues,
        reportType: reportType,
      }));
    };

    /*     const onChangeTimePeriod = (timePeriod: any) => {
          if (timePeriod === DAY) {
            setFormFilterInitialValues((prevInitValues: any) => ({
              ...prevInitValues,
              timePeriod: timePeriod.toString(),
              startDate: "",
              endDate: "",
            }));
          } else {
            setFormFilterInitialValues((prevInitValues: any) => ({
              ...prevInitValues,
              timePeriod: timePeriod.toString(),
              startDate: "",
              endDate: "",
            }));
          }
    
          setSelectedTimePeriod(timePeriod);
          setSelectedStartDate(null);
          setSelectedEndDate(null);
        }; */

    const onChangeStartDate = (startDate: any) => {
      setFormFilterInitialValues((prevInitValues: any) => ({
        ...prevInitValues,
        startDate: startDate,
      }));

      // setSelectedStartDate(startDate);
      // setSelectedEndDate(null);
    };

    const onChangeEndDate = (endDate: any) => {
      setFormFilterInitialValues((prevInitValues: any) => ({
        ...prevInitValues,
        endDate: endDate,
      }));

      // setSelectedEndDate(endDate);
    };

    useEffect(() => {
      return () => {
        setSelectedReportType(null);
      };
    }, []);

    const onSubmitFilter = async () => {
      const form: any = formRef.current;

      if (form) {
        form.handleSubmit();
        const {
          townCouncil,
          site,
          block,
          reportType,
          startDate,
          endDate,
          timePeriod,
          asset,
        } = form.values;

        if (endDate) {
          if (endDate < startDate) {
            setIsFiltered(false);
            return;
          }
        }

        if (
          reportType &&
          townCouncil &&
          site &&
          block &&
          startDate
          // && timePeriod
        ) {
          setSelectedFilteredReportType(reportType);
          getSelectedReportType(reportType);
        } else {
          setIsFiltered(false);
          return;
        }
        onRefetchData(
          townCouncil ? townCouncil : null,
          site ? selectedSite : null,
          block ? selectedBlock : null,
          reportType ? selectedReportType : null,
          startDate ? moment.utc(startDate) : null,
          endDate ? moment.utc(endDate) : null,
          selectedTimePeriod,
          asset ? selectedAsset : null
        );

        setDownloaDocumentPayload({
          townCouncil,
          site,
          block,
          reportType,
          startDate,
          endDate,
          timePeriod: timePeriod || "1",
          asset,
        });

        setIsFiltered(true);
      }
    };

    const onClickDownload = (fileType: any) => {
      const form: any = formRef.current;

      if (form) {
        // form.handleSubmit();

        const {
          townCouncil,
          site,
          block,
          reportType,
          startDate,
          endDate,
          timePeriod,
          asset,
        } = downloaDocumentPayload;

        if (!reportType || !townCouncil || !site || !block || !startDate) {
          return;
        }

        dispatch(
          downloadMotionTrafficReportsFile({
            fileType,
            tcCode: townCouncil ? townCouncil : null,
            siteCode: site ? site : null,
            blockCode: block ? block : null,
            reportType: reportType ? reportType : null,
            startDate: startDate ? moment.utc(startDate) : null,
            endDate: endDate ? moment.utc(endDate) : null,
            timePeriod: timePeriod ? timePeriod : "",
            asset: asset ? asset : null,
          })
        );
      }
    };

    const [formFilterInitialValues, setFormFilterInitialValues] = useState({
      townCouncil: "",
      site: "",
      block: "",
      reportType: "",
      startDate: "",
      endDate: "",
      timePeriod: "",
      asset: "",
    });

    const onReset = () => {
      const form: any = formRef.current;
      form.resetForm();

      setFilterUpdateCount(filterUpdateCount + 1);

      // setSelectedTc(null);
      setSelectedSite(null);
      setSelectedBlock(null);
      setSelectedAsset(null);
      setSelectedReportType(null);
      setSelectedTimePeriod(null);
      // setSelectedStartDate(null);
      // setSelectedEndDate(null);

      setIsFiltered(false);

      setSiteOptions([]);
      setBlockOptions([]);

      setIsAssetSearch(true);
      setSelectedBlock(null);

      setTimeSelected(false);

      setFormFilterInitialValues({
        townCouncil: "",
        site: "",
        block: "",
        reportType: "",
        startDate: "",
        endDate: "",
        timePeriod: "1",
        asset: "",
      });
    };

    const filterActionConfig: any = {
      label: "Search",
      event: onSubmitFilter,
      variant: "primary",
    };

    const reset: any = {
      label: "Reset",
      event: onReset,
      variant: "secondary",
    };
    // const currentDateTime = moment().format("YYYY-MM-DD");

    const thirteenMonthsAgoDay = moment()
      .subtract(13, "months")
      .format("YYYY-MM-DD");

    const yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");

    // const thirteenMonthsAgo = moment().subtract(13, "months").format("YYYY-MM");
    // const thisMonth = moment().format("YYYY-MM");

    const [formConfiguration, setFormConfiguration] = useState<FilterFormConfig>({
      controls: [],
    });

    useEffect(() => {
      setFormConfiguration({ controls: [] });
      const controls: { controlGroup: Control[] }[] = [
        {
          controlGroup: [
            {
              name: "townCouncil",
              placeholder: "Select Town Council *",
              type: "searchable-select",
              options: tcOptions,
              onChange: onChangeTC,
              required: true,
              isLoading: isLoadingTownCouncils,
            },
          ],
        },
        {
          controlGroup: [
            {
              name: "site",
              placeholder: "Select Site *",
              type: "searchable-select",
              options: siteOptions,
              onChange: onChangeSite,
              required: true,
              isLoading: isLocationSitesByTCCode,
            },
          ],
        },
        {
          controlGroup: [
            {
              name: "block",
              placeholder: "Select Block *",
              type: "searchable-select",
              options: blockOptions,
              onChange: onChangeBlock,
              required: true,
              isLoading: isLoadingBlocksBySiteCode,
            },
          ],
        },
        // {
        //   controlGroup: [
        //     {
        //       name: "asset",
        //       placeholder: "All Assets",
        //       type: "searchable-select",
        //       required: false,
        //       selectType: "single",
        //       options: assetOptions,
        //       isLoading: true,
        //       disabled: isAssetSearch,
        //       resetSearchableSelect: blockChangeDetected,
        //       onChange: onChangeAsset,
        //     },
        //   ],
        // },
        {
          controlGroup: [
            {
              name: "reportType",
              placeholder: "Select Report Type *",
              type: "select",
              options: reportTypeOptions,
              onChange: onChangeReportType,
              required: true,
              isLoading: false,
            },
          ],
        },
        // {
        //   controlGroup: [
        //     {
        //       name: "timePeriod",
        //       placeholder: "Select Time Period *",
        //       type: "select",
        //       options: timePeriodOptions,
        //       onChange: onChangeTimePeriod,
        //       required: true,
        //       isLoading: false,
        //     },
        //   ],
        // },
      ];

      if (timeSelected) {
        controls.push({
          controlGroup: [
            {
              name: "asset",
              placeholder: "All Assets",
              type: "searchable-select",
              onChange: onChangeAsset,
              required: false,
              selectType: "single",
              options: assetOptions,
              isLoading: true,
              disabled: isAssetSearch,
              resetSearchableSelect: blockChangeDetected,
            },
          ],
        });
      }

      // setFilterFormConfig((prevConfig: any) => {
      //   const prevControlsJson = JSON.stringify(prevConfig.controls);
      //   const newControlsJson = JSON.stringify(controls);

      //   if (prevControlsJson !== newControlsJson) {
      //     return { controls: controls };
      //   }

      //   return prevConfig;
      // });

      let updatedControls: any = [];
      let dateControls: any = [];
      let monthControls: any = [];

      // if (selectedTimePeriod === MONTH) {
      //   monthControls = [
      //     {
      //       controlGroup: [
      //         {
      //           name: "startDate",
      //           placeholder: "Select Start Month *",
      //           type: "month",
      //           onChange: onChangeStartDate,
      //           required: true,
      //           isLoading: false,
      //           minDate: thirteenMonthsAgo,
      //           maxDate: thisMonth,
      //         },
      //       ],
      //     },
      //     {
      //       controlGroup: [
      //         {
      //           name: "endDate",
      //           placeholder: "Select End Month",
      //           type: "month",
      //           onChange: onChangeEndDate,
      //           required: true,
      //           isLoading: false,
      //           minDate: thirteenMonthsAgo,
      //           maxDate: thisMonth,
      //         },
      //       ],
      //     },
      //   ];
      // }
      // else
      if (selectedTimePeriod === DAY && selectedReportType === "1") {
        dateControls = [
          {
            controlGroup: [
              {
                name: "startDate",
                placeholder: "Select Start Date *",
                type: "date",
                onChange: onChangeStartDate,
                required: true,
                isLoading: false,
                minDate: thirteenMonthsAgoDay,
                maxDate: yesterday,
              },
            ],
          },
          {
            controlGroup: [
              {
                name: "endDate",
                placeholder: "Select End Date",
                type: "date",
                onChange: onChangeEndDate,
                required: true,
                isLoading: false,
                minDate: thirteenMonthsAgoDay,
                maxDate: yesterday,
              },
            ],
          },
        ];
      } else if (selectedTimePeriod === DAY && selectedReportType !== "1") {
        dateControls = [
          {
            controlGroup: [
              {
                name: "startDate",
                placeholder: "Select Date *",
                type: "date",
                onChange: onChangeStartDate,
                required: true,
                isLoading: false,
                minDate: thirteenMonthsAgoDay,
                maxDate: yesterday,
              },
            ],
          },
        ];
      }

      updatedControls = [...controls, ...dateControls, ...monthControls];

      setFormConfiguration({
        controls: updatedControls,
      });
    }, [
      selectedReportType,
      selectedTimePeriod,
      siteOptions,
      tcOptions,
      assetOptions,
      blockOptions,
      timeSelected,
      timePeriodOptions,
    ]);

    useEffect(() => {
      setSiteOptions([]);
      setBlockOptions([]);
      setAssetOptions([]);
      setIsAssetSearch(true);
    }, []);

    useEffect(() => {
      if (selectedFilteredReportType) {
        let isDataEmpty = false;

        switch (selectedFilteredReportType) {
          case "1":
            isDataEmpty = !motionVsTimeData?.countPerHr?.length;
            break;
          case "2":
            isDataEmpty = !motionVsSensorData?.countPerNode?.length;
            break;
          case "3":
            isDataEmpty = !motionCountVsLevelData?.seriesData?.length;
            break;
          case "4":
            isDataEmpty = !motionCountVsLocationData?.seriesData?.length;
            break;
          default:
            break;
        }

        setIsExportDisabled(isDataEmpty);
      } else {
        setIsExportDisabled(false);
      }
    }, [
      selectedFilteredReportType,
      motionVsTimeData,
      motionVsSensorData,
      motionCountVsLevelData,
      motionCountVsLocationData,
    ]);

    // const navigate = useNavigate();

    /*     const redirectToConfiguration = () => {
          navigate("/admin/configuration/reportconfiguration");
        }; */

    const validationSchema = yup.object().shape({
      reportType: yup.number().required("Report Type is required"),
      // timePeriod: yup.number().required("Time Period is required"),
      townCouncil: yup.string().required("Town Council is required"),
      site: yup.string().required("Site is required"),
      block: yup.string().required("Block is required"),
      startDate: yup.date().required(function (value) {
        return selectedTimePeriod === MONTH
          ? "Start Month is required"
          : "Start Date is required";
      }),
      endDate: yup.date().test("end-after-start", function (value, context) {
        const { startDate } = context?.parent || {};

        if (!value || !startDate) return true;

        const errorText =
          selectedTimePeriod === MONTH
            ? "End Month must be after Start Month"
            : "End Date must be after Start Date";

        return (
          new Date(value) >= new Date(startDate) ||
          context?.createError({ message: errorText })
        );
      }),
    });

    const getMotionTrafficXaxisTitle = () => {
      if (selectedTimePeriod == DAY) {
        return formFilterInitialValues?.endDate ? "Time (Date)" : "Time (Hours)";
      } else if (selectedTimePeriod == MONTH) {
        return "Time (Months)";
      } else {
        return "Time (Hours)";
      }
    };

    // useEffect(() => {
    //   debugger
    //   if (selectedReportType) {
    //     setFilterUpdateCount(filterUpdateCount + 1);
    //     setFormFilterInitialValues((prevInitValues: any) => ({
    //       ...prevInitValues,
    //       timePeriod: selectedReportType !== "1" ? "1" : "",
    //     }));
    //     if (selectedReportType === "1") {
    //       setSelectedTimePeriod("1");
    //     }
    //   }
    // }, [selectedReportType]);

    // Motion Traffic specific tooltip formatter
    const motionTrafficTooltipFormatter = (point: any) => {
      const { x, y } = point;

      if (selectedFilteredReportType === "2") {
        // Motion vs Sensor
        const sensorName =
          motionVsSensorData?.sensorIds?.[point.index] || point.category || x;

        // Find location from extraData
        const extraDataItem: any = motionVsSensorData?.extraData?.find(
          (data: any) => data?.displayName === sensorName
        );
        // const location = extraDataItem?.location || "Unknown";
        const level = extraDataItem?.level || "Unknown";

        const SensorName = `<b>Sensor:</b> ${sensorName}<br />`;
        const MotionCount = `<b>Motion Count:</b> ${y}<br />`;
        // const Location = `<b>Location:</b> ${location}<br />`;
        const Level = `<b>Level:</b> ${level}<br />`;

        return `${SensorName}${MotionCount}${Level}`;
      }

      if (selectedFilteredReportType === "1") {
        // Motion vs Time
        const time =
          motionVsTimeData?.reportTime?.[point.index] || point.category || x;
        const xAxisTitle = getMotionTrafficXaxisTitle();

        return `<b>${xAxisTitle}:</b> ${time}<br /><b>Motion Count:</b> ${y}<br />`;
      }
      // Fallback for other report types
      return `<b>Motion Count:</b> ${y} (Report Type: ${selectedFilteredReportType})<br />`;
    };

    let motionTrafficChart: JSX.Element | null = null;

    if (selectedFilteredReportType == 1) {
      motionTrafficChart = (
        <CustomHighChartComponent
          chartTitle="Motion Traffic"
          xAxisCategories={motionVsTimeData?.reportTime}
          SeriesType={"areaspline"}
          seriesData={motionVsTimeData?.countPerHr}
          seriesShowInLegend={false}
          seriesName={"Motion Count"}
          xAxisTitleText={getMotionTrafficXaxisTitle()}
          yAxisTitleText={"Motion Count"}
          colors={["#66b2ff"]}
          fileName={generateFilenameWithTimestamp("Motion Traffic")}
          chartName={"Motion Traffic"}
          tooltipFormatter={motionTrafficTooltipFormatter}
        />
      );
    } else if (selectedFilteredReportType == 2) {
      motionTrafficChart = (
        <CustomHighChartComponent
          chartTitle="Motion Traffic"
          xAxisCategories={motionVsSensorData?.sensorIds}
          SeriesType={"column"}
          seriesData={motionVsSensorData?.countPerNode}
          seriesShowInLegend={false}
          seriesName={"Motion Count"}
          xAxisTitleText={"Sensors"}
          yAxisTitleText={"Motion Count"}
          colors={["#66b2ff"]}
          extraData={motionVsSensorData?.extraData}
          redirectRoute="/asset/"
          fileName={generateFilenameWithTimestamp("Motion Traffic")}
          chartName={"Motion Traffic"}
          tooltipFormatter={motionTrafficTooltipFormatter}
        />
      );
    } else if (selectedFilteredReportType == 3) {
      motionTrafficChart = (
        <CustomStackedChartComponent
          xAxisCategories={motionCountVsLevelData?.xAxisValues}
          SeriesType={"column"}
          seriesData={motionCountVsLevelData?.seriesData}
          seriesShowInLegend={false}
          isShowDataLevels={false}
          isShowStackedColor={false}
          seriesName={"Motion"}
          xAxisTitleText={"Level"}
          yAxisTitleText={"Motion Count"}
          fileName={generateFilenameWithTimestamp("Motion Traffic")}
          chartName={"Motion Traffic"}
        />
      );
    } else if (selectedFilteredReportType == 4) {
      motionTrafficChart = (
        <CustomStackedChartComponent
          xAxisCategories={motionCountVsLocationData?.xAxisValues}
          SeriesType={"column"}
          seriesData={motionCountVsLocationData?.seriesData}
          seriesShowInLegend={false}
          isShowDataLevels={false}
          isShowStackedColor={false}
          seriesName={"Motion"}
          xAxisTitleText={"Location"}
          yAxisTitleText={"Motion Count"}
          fileName={generateFilenameWithTimestamp("Motion Traffic")}
          chartName={"Motion Traffic"}
        />
      );
    }

    return (
      <div>
        {/*       <div className="flex justify-end table-generic-action mb-2">
        <B2Button
          className="icon-text-btn"
          variant="primary"
          onClick={redirectToConfiguration}
        >
          Automatic Report Scheduler
          <FontAwesomeIcon icon={faCalendar} className="fs-7 ms-2" />
        </B2Button>
      </div> */}

        <div>
          <FilterFormComponent
            key={formFilterInitialValues?.townCouncil}
            formRef={formRef}
            initialValues={formFilterInitialValues}
            formConfig={formConfiguration}
            actionConfig={filterActionConfig}
            resetButton={reset}
            validation={validationSchema}
            filterUpdateCount={filterUpdateCount}
          />
        </div>

        <div>
          <CustomSpinnerComponent
            height={"400px"}
            width={"100%"}
            isLoading={isLoading}
          >
            {selectedReportType && selectedFilteredReportType && isFiltered && (
              <div className="my-3">
                <div className="export pt-4 d-flex align-items-center justify-content-end">
                  <HasPermission
                    moduleName="Motion Traffic Report"
                    actionName="Download-Motion Traffic Report"
                    isRoute={false}
                  >
                    <div className="d-flex gap-2">
                      <B2Button
                        variant="light"
                        onClick={() => onClickDownload("downloadPdf")}
                        disabled={isExportDisabled}
                      >
                        <img className="fs-7 me-2" src={pdfIcon} alt="PDF Icon" />
                        {""}Export as PDF
                      </B2Button>

                      <B2Button
                        variant="light"
                        onClick={() => onClickDownload("downloadExcel")}
                        disabled={isExportDisabled}
                      >
                        <img
                          className="fs-7 me-2"
                          src={spreadsheetIcon}
                          alt="Spreadsheet Icon"
                        />{" "}
                        Export as Excel
                      </B2Button>
                    </div>

                    {isLoadingMotionTrafficReportsDownload ? (
                      <Spinner
                        className="ms-2"
                        style={{ color: "#1976D2" }}
                        animation="border"
                        role="status"
                        size="sm"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    ) : null}
                  </HasPermission>
                </div>
                {motionTrafficChart}
              </div>
            )}
          </CustomSpinnerComponent>
        </div>
      </div>
    );
  };

export default MotionTrafficReportTableComponent;
